import { QueryClient } from '@tanstack/react-query'

export const DEFAULT_QUERY_RETRY_COUNT = 1

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: DEFAULT_QUERY_RETRY_COUNT,
    },
  },
})
